<div class="ontario-row">
    <div class="blue-bar-outer ontario-column ontario-small-12">
        <div class="blue-bar">
            <span class="blue-bar-program-name">
                {{programName}}
            </span>
            <span class="blue-bar-program-id">
                {{programId}}
            </span>
        </div>
    </div>
</div>